import { ZipRange } from '@src/services/dropdown.ts';

export const validZipCode = (zipCode: string, zipRange: ZipRange[]) => {
  return zipRange.some((value) => {
    const zipCodeNum = Number(zipCode);

    if (typeof value === 'number') {
      return value === zipCodeNum;
    }

    return zipCodeNum >= value[0] && zipCodeNum <= value[1];
  });
};
